import {CustomerLedgerEntry, type CustomerLedgerEntryData} from "@/types/erp/customerLedgerEntry.ts";
import {SeaInvoice} from "@/types/invoices/SeaInvoice.ts";

export class CustomerLedgerEntryReversal {
    public id: number | null;
    public original_entry_id: number | null;
    public reversal_entry_id: number | null;
    public created_by_user_id: number | null;
    public originalInvoice: CustomerLedgerEntry | null;
    public reversalInvoice: CustomerLedgerEntry | null;

    constructor(data: CustomerLedgerEntryReversalData | void) {
        if (data === undefined) {
            this.id = null;
            this.original_entry_id = null;
            this.reversal_entry_id = null;
            this.created_by_user_id = null;
            this.originalInvoice = null;
            this.reversalInvoice = null;

        } else {
            this.id = data.id;
            this.original_entry_id = data.original_entry_id;
            this.reversal_entry_id = data.reversal_entry_id;
            this.created_by_user_id = data.created_by_user_id;
            this.originalInvoice = null;
            if (data.originalInvoice !== undefined && data.originalInvoice !== null) {
                this.originalInvoice = new CustomerLedgerEntry(data.originalInvoice)
            }
            this.reversalInvoice = null;
            if (data.reversalInvoice !== undefined && data.reversalInvoice !== null) {
                this.reversalInvoice = new CustomerLedgerEntry(data.reversalInvoice)
            }
        }
    }
}

export type CustomerLedgerEntryReversalData = {
    id: number | null;
    original_entry_id: number | null;
    reversal_entry_id: number | null;
    created_by_user_id: number | null;
    originalInvoice: CustomerLedgerEntryData | null | undefined;
    reversalInvoice: CustomerLedgerEntryData | null | undefined;

}